module.exports = __webpack_public_path__ + "static/media/BiharJharkhandChannelPartner.dd5e828e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/BiharJharkhandChannelPartner.jpg
// module id = 833
// module chunks = 11